// extracted by mini-css-extract-plugin
module.exports = {"background":"Iv+y0","confirm":"JcqC9","dialogue":"tDqKS"};